import { io, Socket } from 'socket.io-client'

// Empty string → socket.io-client connects to the current origin (same-domain deploy).
// Unset (dev) → falls back to the local server.
const URL = import.meta.env.VITE_SERVER_URL ?? 'http://localhost:3000'

export const socket: Socket = io(URL, {
  autoConnect: false,
})

export function connectSocket(): void {
  if (!socket.connected) {
    socket.connect()
  }
}

export function disconnectSocket(): void {
  if (socket.connected) {
    socket.disconnect()
  }
}
